import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSpring, animated as a } from 'react-spring';
import onboardingStyles from './onboarding.module.css';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import ExploreIcon from '@mui/icons-material/Explore';
import FavoriteIcon from '@mui/icons-material/Favorite';

function Onboarding() {
  const navigate = useNavigate();

  const fadeIn = useSpring({
    from: { opacity: 0, transform: 'translateY(50px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: { tension: 120, friction: 20 }
  });

  const features = [
    {
      icon: <HeadphonesIcon sx={{ fontSize: 60 }} />,
      title: 'Listen Anywhere',
      description: 'Stream your favorite podcasts on any device'
    },
    {
      icon: <ExploreIcon sx={{ fontSize: 60 }} />,
      title: 'Discover New Shows',
      description: 'Explore thousands of podcasts across all genres'
    },
    {
      icon: <FavoriteIcon sx={{ fontSize: 60 }} />,
      title: 'Save Your Favorites',
      description: 'Create your personal library of episodes'
    }
  ];

  return (
    <div className={onboardingStyles.container}>
      <a.div style={fadeIn} className={onboardingStyles.content}>
        <div className={onboardingStyles.hero}>
          <HeadphonesIcon sx={{ fontSize: 120, color: '#667eea' }} />
          <h1 className={onboardingStyles.title}>Welcome to PodcastApp</h1>
          <p className={onboardingStyles.subtitle}>
            Your gateway to unlimited podcast entertainment
          </p>
        </div>

        <div className={onboardingStyles.features}>
          {features.map((feature, index) => (
            <div key={index} className={onboardingStyles.feature}>
              <div className={onboardingStyles.featureIcon}>{feature.icon}</div>
              <h3 className={onboardingStyles.featureTitle}>{feature.title}</h3>
              <p className={onboardingStyles.featureDesc}>{feature.description}</p>
            </div>
          ))}
        </div>

        <div className={onboardingStyles.actions}>
          <button
            className={onboardingStyles.primaryBtn}
            onClick={() => navigate('/signup')}
          >
            Get Started
          </button>
          <button
            className={onboardingStyles.secondaryBtn}
            onClick={() => navigate('/login')}
          >
            I Already Have an Account
          </button>
        </div>

        <div className={onboardingStyles.testAccount}>
          <p className={onboardingStyles.testAccountText}>
            Want to try it first? Use our test account
          </p>
          <div className={onboardingStyles.credentials}>
            <span>Email: test@podcast.com</span>
            <span>Password: test123</span>
          </div>
        </div>
      </a.div>
    </div>
  );
}

export default Onboarding;
